import {
  createContext, useContext, useEffect, useState,
} from 'react';
import { useAuth } from './AuthContext';
import { subscribeConfig } from '../data/listeners/config';
import { withDefaults } from '../data/proof';

// Active tenant's settings, app-wide. Lets every picker read the customizable
// Tier / Channel lists (and other config) without each view re-subscribing.
const ConfigContext = createContext(undefined);

export function ConfigProvider({ children }) {
  const { tenantId } = useAuth();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (!tenantId) { setConfig(null); return undefined; }
    return subscribeConfig(tenantId, setConfig, () => setConfig(null));
  }, [tenantId]);

  return (
    <ConfigContext.Provider value={{ config: withDefaults(config) }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const ctx = useContext(ConfigContext);
  if (ctx === undefined) throw new Error('useConfig must be used within a ConfigProvider.');
  return ctx;
}
